import React from 'react';
import { useSpring, animated } from 'react-spring';

import { Info, AlertCircle, CheckCircle } from 'react-feather';

import './NotificationBox.css';

// support@everbary.com in a notice can be tapped (only while it's on screen:
// the box takes no clicks, so a hidden link must not catch them either).
const EMAIL = /([\w.+-]+@[\w-]+\.[\w.-]*\w)/;
const withEmailLinks = (text, show) =>
  !show || typeof text !== "string"
    ? text
    : text.split(EMAIL).map((part, i) => (i % 2 ? <a key={i} className="notificationLink" href={`mailto:${part}`}>{part}</a> : part));

const NotificationBox = ({ windowSize, show, title, text, type, action }) => {

  const boxProps = useSpring({ opacity: show ? 1 : 0, right: show ? "30px" : "-400px" , borderBottomColor: type === "error" ? '#dc3545' : type === "success" ? '#28a745' : '#007bff'});
  const color = {color: type === "error" ? '#dc3545' : type === "success" ? '#28a745' : '#007bff'};

  return (
    <animated.div style={boxProps} className="notificationBox" aria-hidden={!show}>
      <div className='notificationWrap'>

      { type === 'info'
      ? <Info className="notificationIcon" style={color} />
      : type === 'error'
      ? <AlertCircle className="notificationIcon" style={color} />
      : <CheckCircle className="notificationIcon" style={color}/>
      }
      <div className="notificationInfo">
        <p className="notificationTitle" style={color}>{title}</p>
        <p className="notificationText" style={color}>{withEmailLinks(text, show)}</p>
      </div>
      {show && action && (
        <button type="button" className="notificationAction" onClick={action.onClick} data-testid="notification-action">
          {action.label}
        </button>
      )}
    </div>

      {/* <div className='notificationLoading'></div> */}
    </animated.div>
  );
}

export { NotificationBox };